import { render, staticRenderFns } from "./accidentReportList.vue?vue&type=template&id=50a268e6&scoped=true&"
import script from "./accidentReportList.vue?vue&type=script&lang=js&"
export * from "./accidentReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a268e6",
  null
  
)

export default component.exports